import React from 'react';
import Layout from '@/common/Layout';
import DrumPublicPage from './components/DrumPublicPage';

const DrumPublic = () => {
  return (
    <Layout sider={false} menuItems={false}>
      <DrumPublicPage />
    </Layout>
  );
};

export default DrumPublic;
